import { loadCollection } from '../../features/folding/folding-actions.js';
import { foldedResultAnalyticsClient } from '../../features/folding/folding-analytics-actions.js';
import { fetchMoreResults } from '../../features/search/search-actions.js';
import { buildCoreFoldedResultList, } from '../core/folded-result-list/headless-core-folded-result-list.js';
/**
 * Creates a `FoldedResultList` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `FoldedResultList` properties.
 * @returns A `FoldedResultList` controller instance.
 *
 * @group Controllers
 * @category FoldedResultList
 */
export function buildFoldedResultList(engine, props = {}) {
    const foldedResultList = buildCoreFoldedResultList(engine, {
        ...props,
        loadCollectionActionCreator: loadCollection,
        fetchMoreResultsActionCreator: fetchMoreResults,
    }, foldedResultAnalyticsClient);
    return {
        ...foldedResultList,
        get state() {
            return foldedResultList.state;
        },
    };
}
